export const SubscriptionCancelReasons = [
  ['customer_service', 'Customer service was less than expected'],
  ['low_quality', 'Quality was less than expected'],
  ['missing_features', 'Some features are missing'],
  ['switched_service', 'I’m switching to a different service'],
  ['too_complex', 'Ease of use was less than expected'],
  ['too_expensive', 'It’s too expensive'],
  ['unused', 'I don’t use the service enough'],
  ['other', 'Other reason'],
] as const;
